<template>
    <div>
        <el-row v-if="chain_done" style="padding-top:40px;">
            <el-col :span="4" style="text-align:center;">
                <h4>Done with assignments by rules</h4>
            </el-col>
            <el-col :span="10" style="text-align:center;">
                <el-button type="primary" @click="go_assignments()">See assignments</el-button>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        props: ['job_chain_id','extent_id','chain_done'],
        data() {
            return {
                ruleset_id: null
            }
        },
        methods: {
            go_assignments() {
                window.location.href = "/assignments"
            }
        }
    }
</script>